module.exports = __webpack_public_path__ + "static/media/view assigned class teacher.65cb3c6e.svg";